import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import TrendingUp from "@material-ui/icons/TrendingUp";
// core components
import { Link } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Info from "components/Typography/Info.jsx";

import brokerage from "assets/img/Kinos/Services/Thumbnails/brokerage.jpg";
import development from "assets/img/Kinos/Services/Thumbnails/development.jpg";
import valuation from "assets/img/Kinos/Services/Thumbnails/valuation.jpg";
import finance from "assets/img/Kinos/Services/Thumbnails/finance.jpg";
import development02 from "assets/img/Kinos/Services/Thumbnails/development02.jpg";
import assetsManagement from "assets/img/Kinos/Services/Thumbnails/assets-management.jpg";
import family_office from "assets/img/Kinos/Services/Thumbnails/family_office-bg.jpg";
import research from "assets/img/Kinos/Services/Thumbnails/research.jpg";
import investment from "assets/img/Kinos/Services/Thumbnails/investment.jpg";

import sectionInterestedStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionInterestedStyle.jsx";

function SectionInterested({ ...props }) {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <h3 className={classes.title + " " + classes.textCenter}>
        You may be interested in...
      </h3>
      <br />
      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/buying-selling" className={classes.dropdownLink}>
                <img src={brokerage} alt="BUYING OR SELLING, BROKERAGE" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + brokerage + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>ENTERPRISE</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/buying-selling" className={classes.dropdownLink}>
                  BUYING & SELLING BROKERAGE
                </Link>
              </h4>
              <p className={classes.description}>
                When it comes to buying and selling property we advise across all residential and commercial markets...
                <Link to="/buying-selling" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/new-developments" className={classes.dropdownLink}>
                <img src={development} alt="NEW DEVELOPMENTS MARKETING & SALES" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + development + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>STARTUPS</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/new-developments" className={classes.dropdownLink}>
                  NEW DEVELOPMENTS MARKETING & SALES
                </Link>
              </h4>
              <p className={classes.description}>
                Bring a modern approach to new development marketing and sales. From boutique rental conversions to luxurious ground-up condominiums, browse our portfolio of current offerings...
                <Link to="/new-developments" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/assets-management" className={classes.dropdownLink}>
                <img src={assetsManagement} alt="assets management" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + assetsManagement + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>
                  ENTERPRISE
                </h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/assets-management" className={classes.dropdownLink}>
                  ASSETS MANAGEMENT
                </Link>
              </h4>
              <p className={classes.description}>
                Helping clients to develop strategy, crete framework for decision making appraising property...
                <Link to="/assets-management" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/family-office" className={classes.dropdownLink}>
                <img src={family_office} alt="..." />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + family_office + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>ENTERPRISE</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/family-office" className={classes.dropdownLink}>
                  FAMILY OFFICE SERVICES
                </Link>
              </h4>
              <p className={classes.description}>
                An objective long-term perspective on investing, structuring and safeguarding assets, to preserve and grow our client's wealth...
                <Link to="/family-office" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/finance" className={classes.dropdownLink}>
                <img src={finance} alt="Finance" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + finance + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>STARTUPS</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/finance" className={classes.dropdownLink}>
                  FINANCE
                </Link>
              </h4>
              <p className={classes.description}>
                Whether investing in a home, buy-to-let property or a portfolio of assets,
                our dedicated teams cover all areas of financial advice, helping clients to make intelligent decisions based on market and sector insights...
                <Link to="/finance" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/investment-services" className={classes.dropdownLink}>
                <img src={investment} alt="..." />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + investment + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>
                  ENTERPRISE
                </h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/investment-services" className={classes.dropdownLink}>
                  INVESTMENT
                </Link>
              </h4>
              <p className={classes.description}>
                INVESTORS, INVESTMENTS , DEAL SOURCING
With specialists and partners working across all property sectors, we are able to advise all types of client on investment opportunities in all corners of the Spain...
                <Link to="/investment-services" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader image plain>
              <Link to="/valuation" className={classes.dropdownLink}>
                <img src={valuation} alt="Valuation" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + valuation + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>ENTERPRISE</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/valuation" className={classes.dropdownLink}>
                  VALUATION
                </Link>
              </h4>
              <p className={classes.description}>
                Kinos provide commercial, residential valuations
to all types of client...
                <Link to="/valuation" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/research" className={classes.dropdownLink}>
                <img src={research} alt="..." />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + research + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>STARTUPS</h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/research" className={classes.dropdownLink}>
                  RESEARCH
                </Link>
              </h4>
              <p className={classes.description}>
                Kinos provide advice and analysis to clients across the Spain, with specialists in commercial, residentiall and world property research...
                <Link to="/research" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
              <Link to="/development" className={classes.dropdownLink}>
                <img src={development02} alt="development" />
              </Link>
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + development02 + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <Info>
                <h6>
                  ENTERPRISE
                </h6>
              </Info>
              <h4 className={classes.cardTitle}>
                <Link to="/development" className={classes.dropdownLink}>
                  DEVELOPMENT
                </Link>
              </h4>
              <p className={classes.description}>
                Froma valuation, land sales and adquisitions throught to funding and portfolio support, we work over all the process...
                <Link to="/development" className={classes.dropdownLink}> Read More </Link>
              </p>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(sectionInterestedStyle)(SectionInterested);
